/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Marius Runde
 * Date: 05.07.2016
 *
 */
'use strict';

import { amdRequire } from 'plugin/liferay-widgets-react-web';
import translateDraw from './DrawerPlugin/translate-leaflet-drawer';
import L from 'external/leaflet';

export default class BoundingboxInputPlugin {

    constructor(props) {
        if (props.onBoundingBoxChanged) {
            this.onBoundingBoxChanged = props.onBoundingBoxChanged.bind(this);
        } else {
            console.error('Required properties onBoundingBoxChanged are undefined!');
        }
    }

    init(map, o) {
        amdRequire([ 'leaflet-draw', 'css!leaflet-draw-css' ], () => {
            translateDraw();
            map.options.drawControl = true;

            this.drawnItems = new L.FeatureGroup();
            map.addLayer(this.drawnItems);

            if (o.boundingBox && o.boundingBox.longitudeMax > 0) {
                this.drawnItems.addLayer(new L.geoJson({
                    geometry: {
                        type: 'Polygon',
                        coordinates: [
                            [ [ o.boundingBox.longitudeMax, o.boundingBox.latitudeMin ],
                                [ o.boundingBox.longitudeMax, o.boundingBox.latitudeMax ],
                                [ o.boundingBox.longitudeMin, o.boundingBox.latitudeMax ],
                                [ o.boundingBox.longitudeMin, o.boundingBox.latitudeMin ],
                                [ o.boundingBox.longitudeMax, o.boundingBox.latitudeMin ] ]
                        ]
                    },
                    type: 'Feature'
                }));
            }

            let drawControl = new L.Control.Draw({
                draw: {
                    circle: false,
                    circlemarker: false,
                    polyline: false,
                    polygon: false,
                    marker: false
                },
                edit: {
                    featureGroup: this.drawnItems
                }
            });
            map.addControl(drawControl);

            map.on(L.Draw.Event.CREATED, this.handleChange.bind(this));
            map.on(L.Draw.Event.EDITED, this.handleChange.bind(this));
            map.on(L.Draw.Event.DELETED, this.handleDelete.bind(this));

        });
    }

    handleChange(e) {
        let layer;

        if (e.layer) {
            layer = e.layer;
        } else {
            layer = e.layers.getLayers()[ 0 ];
        }

        this.drawnItems.clearLayers();
        this.drawnItems.addLayer(layer);

        let geometry = layer.toGeoJSON().geometry;

        const topLeft = geometry.coordinates[ 0 ][ 0 ];
        const botRight = geometry.coordinates[ 0 ][ 2 ];

        this.onBoundingBoxChanged({
            latitudeMax: botRight[ 1 ],
            latitudeMin: topLeft[ 1 ],
            longitudeMax: botRight[ 0 ],
            longitudeMin: topLeft[ 0 ]
        });
    }

    handleDelete(e) {
        this.onBoundingBoxChanged(null);
    }

}



// WEBPACK FOOTER //
// ./js/plugins/BoundingboxInputPlugin.js